export const INITIATIVES_NEW_TASK = {
	MAX_LENGTH: 255,
	MAX_MESSAGE: 'Task description cannot exceed 255 characters'
};
